export var HLS_MIME_TYPE = "application/x-mpegURL";

function getSourceUrl(source) {
  if (typeof source === "string") return source;
  if (!source || typeof source !== "object") return "";
  return source.src || source.url || "";
}

export function isHlsSource(source) {
  var sourceUrl = getSourceUrl(source).toLowerCase();
  var sourceType =
    source && typeof source === "object" && source.type
      ? String(source.type).toLowerCase()
      : "";

  return (
    sourceType.indexOf("mpegurl") !== -1 ||
    sourceType.indexOf("m3u8") !== -1 ||
    sourceUrl.indexOf(".m3u8") !== -1
  );
}

export function normalizeVideoSource(source) {
  var sourceUrl = getSourceUrl(source);
  if (!sourceUrl) return null;

  var normalized =
    source && typeof source === "object"
      ? Object.assign({}, source, { src: sourceUrl })
      : { src: sourceUrl };

  if (isHlsSource(normalized)) {
    normalized.type = HLS_MIME_TYPE;
  } else if (!normalized.type && sourceUrl.toLowerCase().indexOf(".mp4") !== -1) {
    normalized.type = "video/mp4";
  }

  return normalized;
}

export function normalizeVideoSources(value) {
  var candidates = value;

  if (value && !Array.isArray(value) && typeof value === "object") {
    candidates = Array.isArray(value.sources) ? value.sources : [value];
  } else if (!Array.isArray(value)) {
    candidates = value ? [value] : [];
  }

  var normalized = [];
  for (var i = 0; i < candidates.length; i += 1) {
    var source = normalizeVideoSource(candidates[i]);
    if (source) normalized.push(source);
  }

  return normalized;
}

export function orderHlsFirst(sources) {
  var normalized = normalizeVideoSources(sources);
  var hlsSources = [];
  var fallbackSources = [];

  for (var i = 0; i < normalized.length; i += 1) {
    if (isHlsSource(normalized[i])) {
      hlsSources.push(normalized[i]);
    } else {
      fallbackSources.push(normalized[i]);
    }
  }

  return hlsSources.concat(fallbackSources);
}
